import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AlertService } from './../core/services/alert.service';

@Component({
  selector: 'app-global-alert',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './global-alert.component.html',
  styleUrls: ['./global-alert.component.css']
})
export class GlobalAlertComponent {

  alert$;

  constructor(private alertService: AlertService) {
    this.alert$ = this.alertService.alert$;
  }

  close() {
    this.alertService.close();
  }

  confirm() {
    this.alertService.confirmAction();
  }

}
